/**
 * Get the page id from the root element
 */
export const getPageId = () => document.getElementById('root')?.getAttribute('page-id') || '';
